import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6a1e2e48"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "app-shell"
};
const _hoisted_2 = {
  class: "sidebar"
};
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"brand\" data-v-6a1e2e48><div class=\"brand-mark\" aria-hidden=\"true\" data-v-6a1e2e48>PU</div><div class=\"brand-copy\" data-v-6a1e2e48><div class=\"brand-title\" data-v-6a1e2e48>口袋校园</div><div class=\"brand-subtitle\" data-v-6a1e2e48>Campus</div></div></div>", 1);
const _hoisted_4 = {
  class: "nav-list",
  "aria-label": "主导航"
};
const _hoisted_5 = ["aria-current", "onClick"];
const _hoisted_6 = {
  class: "nav-icon",
  "aria-hidden": "true"
};
const _hoisted_7 = {
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.7",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
};
const _hoisted_8 = {
  key: 0,
  d: "M4 10.5 12 4l8 6.5V20a1 1 0 0 1-1 1h-5v-6H10v6H5a1 1 0 0 1-1-1v-9.5Z"
};
const _hoisted_9 = {
  key: 1,
  d: "M8 3v3M16 3v3M4.5 8h15M6 6.5h12A1.5 1.5 0 0 1 19.5 8v11A1.5 1.5 0 0 1 18 20.5H6A1.5 1.5 0 0 1 4.5 19V8A1.5 1.5 0 0 1 6 6.5Z"
};
const _hoisted_10 = {
  key: 2,
  d: "M6 9a6 6 0 1 1 12 0c0 3.5 1.5 5 1.5 5H4.5S6 12.5 6 9Zm4 9.5a2 2 0 0 0 4 0"
};
const _hoisted_11 = {
  key: 3,
  d: "M10 7V5a2 2 0 0 1 2-2h7v18h-7a2 2 0 0 1-2-2v-2M15 12H4m0 0 3-3M4 12l3 3"
};
const _hoisted_12 = {
  key: 4,
  d: "M12 15.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm7.4-3.5-.8-1.8 1.4-2-1.8-1.8-2 1.4L14 7.2 13.5 5h-3L10 7.2 8.2 6.3 6.4 8.1l1.4 2L6.6 12l.8 1.8-1.4 2 1.8 1.8 2-1.4.5 1.8h3l.5-1.8 2 1.4 1.8-1.8-1.4-2 .8-1.8Z"
};
const _hoisted_13 = {
  class: "nav-label"
};
const _hoisted_14 = {
  class: "nav-footer"
};
const _hoisted_15 = {
  class: "session-copy"
};
const _hoisted_16 = {
  class: "workspace"
};
const _hoisted_17 = {
  class: "toolbar"
};
const _hoisted_18 = {
  class: "toolbar-left"
};
const _hoisted_19 = {
  class: "toolbar-title"
};
const _hoisted_20 = {
  class: "toolbar-sub"
};
const _hoisted_21 = {
  class: "toolbar-right"
};
const _hoisted_22 = {
  class: "toolbar-date"
};
const _hoisted_23 = {
  class: "content"
};
import { computed, onMounted, onUnmounted, ref } from "vue";
import Home from "./views/HomePage.vue";
import Login from "./views/LoginPage.vue";
import Event from "./views/EventPage.vue";
import Notice from "./views/NoticePage.vue";
import Settings from "./views/SettingsPage.vue";
import NotFound from "./views/NotFound.vue";
export default {
  __name: 'App',
  setup(__props) {
    const routes = {
      "/": Home,
      "/event": Event,
      "/notice": Notice,
      "/login": Login,
      "/settings": Settings
    };
    const routeMeta = {
      "/": {
        title: "个人总览",
        label: "主页"
      },
      "/event": {
        title: "活动",
        label: "发现"
      },
      "/notice": {
        title: "通知",
        label: "收件箱"
      },
      "/login": {
        title: "登录",
        label: "账户"
      },
      "/settings": {
        title: "设置",
        label: "偏好"
      }
    };
    const navItems = [{
      path: "/",
      label: "主页",
      icon: "home"
    }, {
      path: "/event",
      label: "活动",
      icon: "event"
    }, {
      path: "/notice",
      label: "通知",
      icon: "notice"
    }, {
      path: "/login",
      label: "登录",
      icon: "login"
    }, {
      path: "/settings",
      label: "设置",
      icon: "settings"
    }];
    const currentPath = ref(window.location.hash || "#/");
    const authTick = ref(0);
    const readUserData = () => {
      try {
        return JSON.parse(localStorage.getItem("userData") || "null");
      } catch (error) {
        return null;
      }
    };
    const refreshAuth = () => {
      authTick.value += 1;
    };
    const onHashChange = () => {
      currentPath.value = window.location.hash || "#/";
      refreshAuth();
    };
    const onStorage = event => {
      if (!event.key || event.key === "loggedIn" || event.key === "userData") {
        refreshAuth();
      }
    };
    onMounted(() => {
      window.addEventListener("hashchange", onHashChange);
      window.addEventListener("storage", onStorage);
      window.addEventListener("focus", refreshAuth);
      window.addEventListener("pu-auth-changed", refreshAuth);
      document.addEventListener("visibilitychange", () => {
        if (document.visibilityState === "visible") refreshAuth();
      });
    });
    onUnmounted(() => {
      window.removeEventListener("hashchange", onHashChange);
      window.removeEventListener("storage", onStorage);
      window.removeEventListener("focus", refreshAuth);
      window.removeEventListener("pu-auth-changed", refreshAuth);
    });
    const normalizedPath = computed(() => currentPath.value.slice(1) || "/");
    const currentView = computed(() => routes[normalizedPath.value] || NotFound);
    const currentMeta = computed(() => routeMeta[normalizedPath.value] || {
      title: "未找到",
      label: "404"
    });
    const todayText = computed(() => new Intl.DateTimeFormat("zh-CN", {
      month: "short",
      day: "numeric",
      weekday: "short"
    }).format(new Date()));
    const isLoggedIn = computed(() => {
      authTick.value;
      return localStorage.getItem("loggedIn") === "true" && Boolean(readUserData());
    });
    const sessionName = computed(() => {
      authTick.value;
      const user = readUserData();
      return user?.user_info?.realname || user?.classUserInfo?.realname || user?.realname || user?.user_info?.uname || user?.username || "已登录";
    });
    const sessionHint = computed(() => {
      authTick.value;
      const user = readUserData();
      if (user?.platform === "class" || user?.token && user?.sid && !user?.oauth_token) {
        return "Class";
      }
      if (user?.oauth_token) return "Web";
      return "已连接";
    });
    const handleMenuClick = path => {
      window.location.hash = path;
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("aside", _hoisted_2, [_hoisted_3, _createElementVNode("nav", _hoisted_4, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(navItems, item => {
        return _createElementVNode("button", {
          key: item.path,
          class: _normalizeClass(["nav-item", {
            active: normalizedPath.value === item.path
          }]),
          type: "button",
          "aria-current": normalizedPath.value === item.path ? 'page' : undefined,
          onClick: $event => handleMenuClick(item.path)
        }, [_createElementVNode("span", _hoisted_6, [(_openBlock(), _createElementBlock("svg", _hoisted_7, [item.icon === 'home' ? (_openBlock(), _createElementBlock("path", _hoisted_8)) : item.icon === 'event' ? (_openBlock(), _createElementBlock("path", _hoisted_9)) : item.icon === 'notice' ? (_openBlock(), _createElementBlock("path", _hoisted_10)) : item.icon === 'login' ? (_openBlock(), _createElementBlock("path", _hoisted_11)) : item.icon === 'settings' ? (_openBlock(), _createElementBlock("path", _hoisted_12)) : _createCommentVNode("", true)]))]), _createElementVNode("span", _hoisted_13, _toDisplayString(item.label), 1)], 10, _hoisted_5);
      }), 64))]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", {
        class: _normalizeClass(["session-chip", {
          online: isLoggedIn.value
        }])
      }, [_createElementVNode("span", {
        class: _normalizeClass(["status-dot", isLoggedIn.value ? 'online' : 'offline']),
        "aria-hidden": "true"
      }, null, 2), _createElementVNode("div", _hoisted_15, [_createElementVNode("strong", null, _toDisplayString(isLoggedIn.value ? sessionName.value : '未登录'), 1), _createElementVNode("small", null, _toDisplayString(isLoggedIn.value ? sessionHint.value : '登录后同步数据'), 1)])], 2)])]), _createElementVNode("main", _hoisted_16, [_createElementVNode("header", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createElementVNode("h1", _hoisted_19, _toDisplayString(currentMeta.value.title), 1), _createElementVNode("span", _hoisted_20, _toDisplayString(currentMeta.value.label), 1)]), _createElementVNode("div", _hoisted_21, [_createElementVNode("span", _hoisted_22, _toDisplayString(todayText.value), 1)])]), _createElementVNode("section", _hoisted_23, [(_openBlock(), _createElementBlock("div", {
        class: "view-enter",
        key: normalizedPath.value
      }, [(_openBlock(), _createBlock(_resolveDynamicComponent(currentView.value)))]))])])]);
    };
  }
};